import { styled } from 'styled-components'

export const SocialNetworkComponent = styled.a`
  height: 25px;
  width: 25px;

  & svg {
    height: 100%;
    width: 100%;
  }
`
